// src/features/audit/components/AuditStatusBadge.tsx
import type { AuditStatus } from '../data/audit.mock';

export interface AuditStatusBadgeProps {
  status: AuditStatus;
}

const STATUS_LABEL: Record<AuditStatus, string> = {
  success: 'موفق',
  warning: 'هشدار',
  failed: 'ناموفق',
};

const STATUS_COLOR_VAR: Record<AuditStatus, string> = {
  success: 'var(--vania-accent-teal, #2fd6a7)',
  warning: 'var(--vania-accent-amber, #f5b942)',
  failed: 'var(--vania-accent-rose, #ff6b81)',
};

/**
 * Small pill badge mapping an audit record's raw status to its
 * Persian label + accent color. Same status-badge shape used by
 * security/components/SecurityStatusBadge.tsx and
 * orders/components/OrderStatusBadge.tsx (label map + color-var map
 * keyed by the union type) — kept local to this feature since the
 * union (success/warning/failed) is audit-specific.
 */
export function AuditStatusBadge({ status }: AuditStatusBadgeProps) {
  const color = STATUS_COLOR_VAR[status];

  return (
    <span className="vania-audit-status-badge" style={{ color, borderColor: color }}>
      <span aria-hidden className="vania-audit-status-dot" style={{ backgroundColor: color }} />
      {STATUS_LABEL[status]}
    </span>
  );
}
